//
import React from 'react'
import AppContext from "../../context/AppContext";
//
import Index from "./box-item/Index";
import View from "./box-item/View";
import Create from "./box-item/Create";
import Update from "./box-item/Update";
import NoPage from "../NoPage";

class BoxItem extends React.Component {

    static contextType = AppContext;

    /**
     * @return {AppBase}
     */
    app = () => {
        return this.context;
    }

    render = () => {
        let $pages = []
        let $app = this.app()

        $pages.push($app.content.showPage(<Index/>, 'Box-Item', 'Index'))
        $pages.push($app.content.showPage(<Create/>, 'Box-Item', 'Create'))
        $pages.push($app.content.showPage(<Update/>, 'Box-Item', 'Update'))
        $pages.push($app.content.showPage(<View/>, 'Box-Item', 'View'))

        return ($pages.join('') === '' ? <NoPage/> : $pages);
    }
}

export default BoxItem;